"use strict";

var _classCallCheck = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Trail = void 0;

var Utils_1 = require("../../../../Utils");

var Trail = /*#__PURE__*/function () {
  function Trail() {
    _classCallCheck(this, Trail);

    this.delay = 1;
    this.pauseOnStop = false;
    this.quantity = 1;
  }

  _createClass(Trail, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }

      if (data.delay !== undefined) {
        this.delay = data.delay;
      }

      if (data.quantity !== undefined) {
        this.quantity = data.quantity;
      }

      if (data.particles !== undefined) {
        this.particles = (0, Utils_1.deepExtend)({}, data.particles);
      }

      if (data.pauseOnStop !== undefined) {
        this.pauseOnStop = data.pauseOnStop;
      }
    }
  }]);

  return Trail;
}();

exports.Trail = Trail;